/// <reference path="../../../teva/selectbox/selectbox.ts" />
/// <reference path="../../../teva/sortable/sortable.ts" />
/// <reference path="../../common/modals/modals.ts" />
/// <reference path="../propertypicker/propertypicker.ts" />
/// <reference path="../viewpicker/viewpicker.ts" />

namespace OfficeGuy.CRM {
    export class SchemaDetails {
        static InitPropertiesIndex() {
            Teva.Sortable.Enable($(".Properties"), {
                HandleSelector: ".icon-drag",
                OnChange: function () {
                    SchemaDetails.ReindexProperties();
                    Common.InitEditors();
                }
            });
            SchemaDetails.ReindexProperties();
            $('#Properties').find('tfoot').toggle($('.Properties tr').length > 0);
        }

        static RemoveProperty($Row) {
            var RowID = $("input:first", $Row).attr("name").substring("Properties[".length);
            RowID = RowID.substring(0, RowID.indexOf(']'));

            OfficeGuy.Forms.NestedForm_Remove(null, 'Properties', RowID);
            $Row.remove();
        }

        static ReindexProperties(): void {
            var Index = 0;
            $(".Properties input[name*=Index]").each(function () {
                $(this).val((Index++).toString());
            });
        }
        static RestoreView(SchemaID): boolean {
            OfficeGuy.CRM.ViewPicker.ShowViewPicker(SchemaID, (ViewID) => {
                Common.AjaxRequest({
                    URL: "/views/restore/",
                    Data: {
                        SchemaID: SchemaID,
                        ViewID: ViewID
                    }
                });
            }, true);
            return false;
        }
        static RestoreProperty(SchemaID): boolean {
            OfficeGuy.CRM.PropertyPicker.ShowPropertyPicker(SchemaID, (Path, Name, PathNames, PropertyValueType) => {
                Common.AjaxRequest({
                    URL: "/schema/restoreproperty/",
                    Data: { ID: Path }
                });
            }, true, true, true);
            return false;
        }

        static DefaultValueTypeChanged($Element): void {
            var SelectedValue = $Element.val();
            var Container = $Element.closest("tr, form");

            var $DefaultValue = $("#DefaultValuePicker_Value", Container);
            var $DefaultValueTemplate = $("#DefaultValuePicker_Template", Container);
            var $AutomaticValue = $("#DefaultValuePicker_AutomaticValue", Container);
            var $AutoIncrement = $("#DefaultValuePicker_AutoIncrement", Container);
            $DefaultValue.toggle(SelectedValue == "1");
            $DefaultValueTemplate.toggle(SelectedValue == "2" || SelectedValue == "3");
            $AutomaticValue.toggle(SelectedValue == "4");
            var AutomaticValueValue = $("#DefaultValuePicker_AutomaticValue").find("select").length > 0 ? $("#DefaultValuePicker_AutomaticValue").find("select").val() : $("#DefaultValuePicker_AutomaticValue").find("input:hidden:first").val();
            $AutoIncrement.toggle(SelectedValue == "4" && AutomaticValueValue == "5");

            //if (SelectedValue != "1") {
            //    $("input:not(:checkbox):not([name='Property.DefaultValue.PropertyID'])", $DefaultValue).val("");
            //    $(".og-richtexteditor", $DefaultValue).empty();
            //}
            //if (SelectedValue != "2" && SelectedValue != "3")
            //    $("input", $DefaultValueTemplate).val("");
            //if (SelectedValue != "4")
            //    $("select", $AutomaticValue).val("");
        }

        static AutomaticValueChanged($Select): void {
            $("#DefaultValuePicker_AutoIncrement").toggle($Select.val() == "5");
            $Select.nextAll("input:hidden:first").val($Select.val() == "3" ? Teva.SelectBox.GetInstance($Select).SelectedData.automaticcrmid : "");
        }

        static ShowTemplatePicker(EntityID, $Input, Computed): void {
            OfficeGuy.CRM.PropertyPicker.ShowPropertyPicker(EntityID, function (Path, Name, PathNames) {
                $Input.val($Input.val() + "{" + PathNames + "}").trigger("change");
            }, null, null, null, null, !Computed);
        }

        static ShowSchemaRestore(): void {
            var $Modal = OfficeGuy.Modals.Create({
                Title: "בחירת תיקייה"
            });

            Common.AjaxRequest({
                Method: 'GET',
                URL: "/schema/schemapicker/?schemastatus=Deleted",
                SuccessMethod: function (data) {
                    if (data.length == 0) {
                        OfficeGuy.Modals.UpdateBody($Modal, OfficeGuy.Resources.GetString("CRM", "NoSchemasToRecover"));
                        return;
                    }
                    var $MainDiv = $(document.createElement('div'));

                    for (var i = 0; i < data.length; i++) {
                        var Application = data[i];
                        var $UL = $(document.createElement('ul'));
                        $(document.createElement('div'))
                            .append($(document.createElement('h4'))
                                .text(Application.text))
                            .append($UL)
                            .appendTo($MainDiv);
                        for (var j = 0; j < Application.children.length; j++) {
                            var Item = Application.children[j];
                            if (Item.disabled)
                                continue;

                            $UL.append($(document.createElement('li'))
                                .append($(document.createElement('a'))
                                    .attr("href", "#")
                                    .data("SchemaID", Item.id)
                                    .text(Item.text)
                                    .on("click", function () {
                                        Modals.ShowURLModal("/schema/restoreschema/?id=" + $(this).data("SchemaID"));
                                    })
                                ));
                        }
                    }
                    OfficeGuy.Modals.UpdateBody($Modal, function (BodyContainer) {
                        $MainDiv.appendTo(BodyContainer);
                    });
                }
            });
        }

        static PropertyDetails_NewValueTypeChanged(Value, Text, Data, Instance) {
            if (Value == "Entity") {
                $(".og-crm-schema-propertydetails-newschemaproperty").show();
                $(".og-crm-schema-propertydetails-valueschemaid input:hidden").val(Data.schemaid);
                $(".og-crm-schema-propertydetails-newschemaproperty input.simplepropertypicker:hidden").data("schemaid", Data.schemaid);
            }
            else {
                $(".og-crm-schema-propertydetails-newschemaproperty").hide();
                $(".og-crm-schema-propertydetails-valueschemaid input:hidden").val(null);
                $(".og-crm-schema-propertydetails-newschemaproperty input.simplepropertypicker:hidden").data("schemaid", null);
            }
            Teva.SelectBox.GetInstance($(".og-crm-schema-propertydetails-newschemaproperty input.simplepropertypicker:hidden")).ClearCache();
            Teva.SelectBox.GetInstance($(".og-crm-schema-propertydetails-newschemaproperty input.simplepropertypicker:hidden")).ClearValue();
        }

        static PropertyDetails_ValueTypeChangedWarning(PreviousValueType) {
            //var ValueType = Teva.SelectBox.GetInstance($("form.propertydetails input.valuetype")).SelectedValue;
            //if (ValueType == PreviousValueType)
                return true;

            //var $Modal = OfficeGuy.Modals.ShowConfirmDialog({
            //    Title: "שמירת ושינוי סוג נתונים",
            //    Message: "שים לב! ביקשת להחליף את סוג הנתונים בשדה. שינוי זה עלול לארוך עד דקה. האם ברצונך להמשיך?" + (PreviousValueType == "Entity" ? "<br />חשוב! לא ניתן לבטל או לחזור אחורה משינוי סוג נתונים של שדה מסוג כרטיס לשדה מסוג אחר. נתונים מסוימים עלולים להמחק כתוצאה מתהליך זה." : ""),
            //    ConfirmEvent: function () {
            //        Modals.Hide($Modal);
            //        $("form.propertydetails").trigger("submit");
            //    }
            //});
            //return false;
        }
    }
} 